import { Link } from "react-router-dom";

export default function Mitra() {
  return (
    <div data-testid="page-mitra">
      <div className="pe-container pt-14 pb-16">
        <div className="pe-eyebrow">Mitra</div>
        <h1 className="mt-2 font-display font-bold text-3xl lg:text-4xl">Untuk arsitek & developer</h1>
        <p className="mt-4 text-[color:var(--pe-text-muted)] max-w-2xl">
          Masukkan kebutuhan atap, area perangkat, jalur kabel, dan akses perawatan sejak tahap desain. Proper Energy mendampingi mulai review schematic hingga serah terima.
        </p>
        <div className="mt-10 grid md:grid-cols-3 gap-5">
          {[
            { t: "Review desain atap & struktur", d: "Pengecekan beban modul, bidang atap, dan aksesibilitas pemasangan." },
            { t: "Jalur kabel & panel distribusi", d: "Rekomendasi jalur kabel AC/DC, proteksi, dan integrasi beban prioritas." },
            { t: "Rencana tumbuh terintegrasi", d: "Siapkan slot inverter & baterai untuk pengembangan tanpa pekerjaan ulang." },
          ].map((x, i) => (
            <div key={i} className="pe-card">
              <h3 className="font-display font-semibold text-lg">{x.t}</h3>
              <p className="mt-2 text-[color:var(--pe-text-muted)]">{x.d}</p>
            </div>
          ))}
        </div>
        <div className="mt-10 pe-card">
          <h3 className="font-display font-semibold">Diskusi proyek bersama</h3>
          <p className="mt-2 text-[color:var(--pe-text-muted)]">
            Hubungi kami dan sebutkan tahap desain Bapak/Ibu — kami tidak menerapkan skema komisi otomatis; ketentuan kemitraan disusun per proyek.
          </p>
          <Link to="/kontak" className="pe-btn-primary mt-5" data-testid="mitra-cta">Hubungi tim engineering</Link>
        </div>
      </div>
    </div>
  );
}
